import { IAttachment } from "@ramudden/models/attachment";
import { FileUtils } from "./file-utils";

/** The bits of an attachment needed to work out what to show for it. */
export interface IDisplayableAttachment {
    url: string;
    thumbnailUrl?: string;
}

export class AttachmentUtils {
    /**
     * The URL to put in an img src for this attachment.
     *
     * For images that's the thumbnail when the server has one, falling back to the original so this keeps working
     * for attachments uploaded before thumbnails existed. Anything that isn't an image gets its type placeholder.
     *
     * Note that this never fetches anything: the browser does that, which is what lets it load images in parallel,
     * skip the ones that are off screen, and reuse its own cache on the way back.
     */
    static getDisplayUrl(attachment: IDisplayableAttachment): string {
        if (!attachment?.url) return null;

        if (!FileUtils.isPhotoUrl(attachment.url)) return FileUtils.getPreviewFromFilename(attachment.url);

        return attachment.thumbnailUrl || attachment.url;
    }

    static processLoadedAttachments(attachments: IAttachment[]) {
        if (!attachments) return;

        for (const attachment of attachments) {
            attachment.preview = AttachmentUtils.getDisplayUrl(attachment);
        }
    }
}
